import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        surveyGroup: '=',
        uibModalInstance: '=',
        company: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'survey.Edit translations' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="form">
                <table class="data01">
                <thead>
                    <tr>
                        <th>{{ 'survey.Language' | translate }}</th>
                        <th>{{ 'survey.Active' | translate }}</th>
                        <th>{{ 'survey.Survey group name' | translate }}</th>
                        <th>{{ 'survey.Introduction text' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="(code, value) in vm.languages">
                        <td>{{ vm.COMPANY_LANGUAGE_ENUM.LABELS[code] }}</td>
                        <td>
                            <label class="switch01">
                                <input ng-if="code === vm.defaultLanguage"
                                    type="checkbox"
                                    name="switch"
                                    ng-checked="true"
                                    ng-disabled="true"
                                />
                                <input ng-if="code !== vm.defaultLanguage"
                                    type="checkbox"
                                    name="switch"
                                    ng-model="vm.languages[code]"
                                    ng-change="vm.toggleTranslation(code)"
                                    ng-disabled="code === vm.defaultLanguage"
                                />
                                <span></span>
                            </label>
                        </td>
                        <td>
                            <form-row error="vm.form.errors.surveyGroupI18ns[code].name" additional-classes="'row-wide'">
                                <div class="items">
                                    <input
                                        ng-model="vm.form.model.surveyGroupI18ns[code].name"
                                        type="text"
                                        class="form-control"
                                        ng-if="vm.languages[code] || code === vm.defaultLanguage"
                                    />
                                    <form-row-error></form-row-error>
                                </div>
                            </form-row>
                        </td>
                        <td>
                            <ng-ckeditor
                                ng-model="vm.form.model.surveyGroupI18ns[code].introduction"
                                ng-config="vm.ckConfig"
                                ng-if="vm.languages[code] || code === vm.defaultLanguage"
                            />
                            <form-row error="vm.form.errors.surveyGroupI18ns[code].introduction">
                                <form-row-error></form-row-error>
                            </form-row>
                            <p ng-if="vm.languages[code] && vm.errors[code]" class="desc error row has-error">{{ vm.errors[code] }}</small></p>
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, FormFactory, FormResource,
                 SurveyService, ModalService, TokenService, COMPANY_LANGUAGE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.SurveyService = SurveyService;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
    }

    $onInit () {
        this.defaultLanguage = this.company.defaultLanguage;
        const companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();

        this.form = this.FormFactory.createFromResource(
            this.surveyGroup,
            { expand: 'formActiveI18n,sortedByNameParticipants,users,activeI18n,surveyGroupI18ns' }
        );
        this.SurveyService.convertFormFields(this.form);
        this.ckConfig = this.SurveyService.getCKEditorConfig();

        const foreignLanguages = {};
        this.lodash.forEach(companySupportedLanguages, (code) => {
            if (code !== this.company.defaultLanguage) {
                foreignLanguages[code] = this.lodash.has(this.surveyGroup.surveyGroupI18ns, code);
            }
        });

        let hasDefaultIntroduction = true;
        if (!this.surveyGroup.surveyGroupI18ns[this.company.defaultLanguage].introduction) {
            hasDefaultIntroduction = false;
        }
        // add company language in the beginning, so it appears fist in UI
        this.languages = this.lodash.merge({ [this.company.defaultLanguage]: hasDefaultIntroduction }, foreignLanguages);
    }

    toggleTranslation (code) {
        const confirmMessage = this.$translate.instant('survey.Are you sure you would like to remove this translation?');
        if (!this.languages[code]) {
            // leave checkbox checked
            this.languages[code] = !this.languages[code];
            this.ModalService.confirm(confirmMessage, 'medium').then(() => {
                // uncheck if confirmed
                this.languages[code] = !this.languages[code];
                if (code === this.company.defaultLanguage) {
                    // in case of company language just nullify introduction field not entire i18n entry
                    // this strange logic here is due to inconsistent UI flow
                    this.form.model.surveyGroupI18ns[code].introduction = null;
                }
                else {
                    delete this.form.model.surveyGroupI18ns[code];
                }
            });
        }
        else {
            this.form.model.surveyGroupI18ns[code] = '';
        }
    }

    save () {
        if (this.lodash.isEmpty(this.errors)) {
            this.form.save().then((updatedSurveyGroup) => {
                this.uibModalInstance.close(updatedSurveyGroup);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/survey/translation/index.js